<template>
  <div>
  <navbar></navbar>
  <slot />
  <footerv></footerv>
  </div>
</template>

<script>
import navbar from '../components/navbar';
import footerv from '../components/footerv';

export default {
components:{
navbar ,
footerv
}
}
</script>

<style>

</style>